import React from 'react';
import classes from './GlowButton.module.scss';


const GlowButton = ({children, onClick, disabled = false}) => {
    return (
        <button className={classes.Button} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
};

export default GlowButton;